export default "__VITE_ASSET__D5JQNhzQ__"